import ServicePriceList from '../../services/ipanel/ServicePriceList.js'
import Vue from 'vue'

export const namespaced = true

export const state = {
    categoryList: [],
    photoList: [],
    photoCount: 0,
    categoryDetail: null,
    photoDetail: null
}

export const mutations = {
    SET_CATEGORY_LIST(state, categories) {
        state.categoryList = categories.sort((a, b) => a.sort_order - b.sort_order)
    },
    SET_PHOTO_LIST(state, data) {
        const list = data.results || data
        state.photoList = list.sort((a, b) => a.sort_order - b.sort_order)
        state.photoCount = data.count || (data.results ? data.results.length : data.length)
    },
    SET_CATEGORY_DETAIL(state, category) {
        state.categoryDetail = category
    },
    SET_PHOTO_DETAIL(state, photo) {
        state.photoDetail = photo
    },
    ADD_CATEGORY(state, category) {
        state.categoryList.push(category)
        state.categoryList.sort((a, b) => a.sort_order - b.sort_order)
    },
    UPDATE_CATEGORY(state, updatedCategory) {
        const index = state.categoryList.findIndex(c => c.id === updatedCategory.id)
        if (index !== -1) {
            Vue.set(state.categoryList, index, updatedCategory)
        }
        state.categoryList.sort((a, b) => a.sort_order - b.sort_order)
    },
    DELETE_CATEGORY(state, id) {
        state.categoryList = state.categoryList.filter(c => c.id !== id)
    },
    DELETE_PHOTO(state, id) {
        state.photoList = state.photoList.filter(p => p.id !== id)
        state.photoCount--
    }
}

export const actions = {
    fetchCategories({ commit }) {
        return ServicePriceList.getCategoryList()
            .then(resp => {
                commit('SET_CATEGORY_LIST', resp.data.results || resp.data)
            })
    },
    fetchPhotos({ commit }, params) {
        return ServicePriceList.getPhotoList(params)
            .then(resp => {
                commit('SET_PHOTO_LIST', resp.data)
            })
    },
    createCategory({ commit }, data) {
        return ServicePriceList.createCategory(data)
            .then(resp => {
                commit('ADD_CATEGORY', resp.data)
                Vue.toasted.success('Category created successfully')
            })
    },
    updateCategory({ commit }, { id, data }) {
        return ServicePriceList.updateCategory(id, data)
            .then(resp => {
                commit('UPDATE_CATEGORY', resp.data)
            })
    },
    deleteCategory({ commit }, id) {
        return ServicePriceList.deleteCategory(id)
            .then(() => {
                commit('DELETE_CATEGORY', id)
                Vue.toasted.success('Category deleted successfully')
            })
    },
    createPhoto({ commit, dispatch }, data) {
        return ServicePriceList.createPhoto(data)
            .then(resp => {
                dispatch('fetchPhotos')
                // Also refresh categories to update photos_count
                dispatch('fetchCategories')
                Vue.toasted.success('Photo uploaded successfully')
            })
    },
    updatePhoto({ commit, dispatch }, { id, data, skipRefreshCategories = false }) {
        return ServicePriceList.updatePhoto(id, data)
            .then(resp => {
                dispatch('fetchPhotos')
                // Also refresh categories to update photos_count
                if (!skipRefreshCategories) {
                    dispatch('fetchCategories')
                }
                Vue.toasted.success('Photo updated successfully')
            })
    },
    deletePhoto({ commit }, id) {
        return ServicePriceList.deletePhoto(id)
            .then(() => {
                commit('DELETE_PHOTO', id)
                Vue.toasted.success('Photo deleted successfully')
            })
    }
}
